import { MutationTree, Mutation } from 'vuex';
import { IState, IFilter, IFilterValue } from './state';
import { ActionPayload, ISetFilterOpenPayload, IToggleFilterValuePayload } from './actions';

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const initApp: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);

	const selectedDates = state.filters.dates.values
		.reduce((selectedMonths, date) => selectedMonths.concat(date.months.filter(month => month.selected)), [] as IFilterValue[])
		.map(v => ({ ...v, filterName: 'dates' }));

	const selectedTags = state.filters.tags.values
		.filter(v => v.selected)
		.map(v => ({ ...v, filterName: 'tags' }));

	state.selectedFilterValues = [
		...selectedDates,
		...selectedTags
	]
}

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
}

const setFilterOpen: MutationHandler<ISetFilterOpenPayload> = (state, { payload }) => {
	if(typeof state.filters[payload.name] === 'object') {
		(state.filters[payload.name] as IFilter).open = payload.open;
	}
}

const toggleFilterValue: MutationHandler<IToggleFilterValuePayload> = (state, { payload }) => {
	let filterValue = undefined;
	if(payload.name === 'dates') {
		filterValue = state.filters.dates.values.reduce((theValue, year) => {
			if(!theValue) {
				return year.months.find(month => month.value === payload.value.value);
			}
			return theValue;
		}, undefined as IFilterValue | undefined)
	} else {
		filterValue = state.filters[payload.name].values.find(filterValue => filterValue.value === payload.value.value);
	}

	if(filterValue) {
		filterValue.selected = !filterValue.selected;
		if(filterValue.selected) {
			state.selectedFilterValues.push({
				...payload.value,
				filterName: payload.name
			});
		} else {
			state.selectedFilterValues = state.selectedFilterValues.filter(val => val.value !== payload.value.value);
		}
	}
}

const setPage: MutationHandler<number> = (state, { payload }) => {
	state.pagination.current = payload;
}


const mutations: MutationTree<IState> = {
	initApp,
	setState: setStateMutation,
	setFilterOpen,
	toggleFilterValue,
	setPage,
}

export default mutations
